import { withStyles } from "@material-ui/core";
import styles from "./styles";
import Detail from "./PickupDetails/Detail";
import { formatPhone } from "../../../../utils/utils";
import {
  REQUESTOR_API_FIELDS,
  normalizePhoneDigits,
} from "../../PickupManagement/ReservationRequestorInfo/utils";

const RequestorDetails = ({ classes, data }) => {
  const F = REQUESTOR_API_FIELDS;
  const digits = normalizePhoneDigits(data?.[F.PHONE]);

  return (
    <div className={classes.requestorContainer}>
      <div className={classes.sectionTitle}>Requestor Info</div>
      <div className={classes.billInfoContainer}>
        <Detail title="Name:" value={data?.[F.NAME]} />
        <Detail title="Company:" value={data?.[F.COMPANY]} />
        <Detail
          title="Phone:"
          value={digits.length === 10 ? formatPhone(digits) : data?.[F.PHONE]}
        />
        <Detail title="Email:" value={data?.[F.EMAIL]} />
      </div>
    </div>
  );
};

export default withStyles(styles)(RequestorDetails);
